import React from 'react';
import { Link } from 'react-router-dom';
// Components
import MailingForm from '../forms/MailingForm';
// Constants
import { MAILING_LIST_UNSUBSCRIBE_PAGE_URL } from '../../utils/constants/Routes';

function MailingSignUpPageMainContainer() {
  return (
    <main role='main' className='grid w-full h-full pb-12'>
      {/* Form section */}
      <section className='grid w-full items-center'>
        <div className='grid w-full px-6 lg:container lg:mx-auto'>
          <section className='grid border-4 h-fit border-colour8 border-solid rounded-xl shadow-2xl w-full bg-colour5 max-w-2xl mx-auto'>
            <div className='grid gap-4 w-full h-full px-8 py-6'>
              {/* Contact form */}
              <section>
                <MailingForm />
              </section>
            </div>
          </section>
        </div>

        <div className='grid h-fit items-center text-center'><p>To unsubscribe <Link to={MAILING_LIST_UNSUBSCRIBE_PAGE_URL}>Click Here</Link></p></div>
      </section>
    </main>
  );
}

export default MailingSignUpPageMainContainer;
